<template>
  <template v-if="unleash.isEnabled('TreatwellStore')" >
    <BaseVisualBanner
      :heading="t('store_banner.heading')"
      :description="t('store_banner.description')"
      imagePath="/img/store/header.svg"
      :primaryAction="{
        text: t('store_banner.primary_action_text'),
        routerLink: { name: 'store' } 
      }"
      :secondaryAction="{
        text: t('store_banner.secondary_action_text'),
        href: 'https://help.salonized.com/articles/10856369' 
      }"
      color="purple"
      variant="light"
      mb
      mt
      v-test="'store-banner'"
      @primaryAction="handlePrimaryActionClick"
      @secondaryAction="handleSecondaryActionClick"
    />
  </template>
</template>

<script setup lang="ts">
import unleash from '@/unleash';
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const mixpanel = inject<any>('mixpanel');
const router = useRouter();

function handlePrimaryActionClick() {
  mixpanel?.track('Store Banner Primary Action Clicked', {
    component: 'StoreBanner',
    action_type: 'primary',
  });
  router.push({ name: 'store' });
}

function handleSecondaryActionClick() {
  mixpanel?.track('Store Banner Secondary Action Clicked', {
    component: 'StoreBanner',
    action_type: 'secondary',
  });
  // For external links, we can directly navigate after tracking
  window.open('https://help.salonized.com/articles/10856369', '_blank');
}
</script>
